import React, { useEffect } from "react";
import "./SideDrawer.scss";
import Button from "../Button/Button";

interface SideDrawerProps {
  isOpen: boolean;
  showHeader?: boolean;
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
  position?: "left" | "right"; // Determines the side of the drawer
  // Add optional save button props
  showSaveButton?: boolean;
  onSave?: () => void;
  isSaveLoading?: boolean;
}

const SideDrawer: React.FC<SideDrawerProps> = ({
  isOpen,
  showHeader = true,
  title,
  onClose,
  children,
  position = "right",
  showSaveButton = false,
  onSave,
  isSaveLoading = false,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Disable background scroll
    } else {
      document.body.style.overflow = ""; // Restore background scroll
    }
    return () => {
      document.body.style.overflow = ""; // Cleanup
    };
  }, [isOpen]);

  return (
    <div className={`side-drawer ${isOpen ? "open" : ""}`} onClick={onClose}>
      <div
        className={`side-drawer-content ${position}`}
        onClick={(e) => e.stopPropagation()} // Prevent click propagation
      >
        {showHeader && (
          <div className="header-container">
            <div className="title">{title}</div>
            {showSaveButton && onSave && (
              <Button
                className="save-button"
                onClick={onSave}
                disabled={isSaveLoading}
              >
                Save
              </Button>
            )}
            <button className="close-btn" onClick={onClose}>
              &times;
            </button>
          </div>
        )}
        <div className="side-drawer-main-content">{children}</div>
      </div>
    </div>
  );
};

export default SideDrawer;
